<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { NameFormModal } from '../name-form-modal';

// Names the duplicate a "Kopiera" action is about to create. All the form behaviour (focus, select,
// trim, Enter-to-submit) lives in NameFormModal; this owns only copy's own strings and emit name.
//
// `initialName` arrives pre-filled with a non-colliding " (n)" base and is selected on open, so the
// common case — accept it, or replace the whole thing in one keystroke — costs a single action.

const { t } = useI18n();

defineProps<{
  initialName: string;
}>();

const emit = defineEmits<{
  (e: 'close'): void;
  (e: 'copy', newName: string): void;
}>();
</script>

<template>
  <NameFormModal
    :title="t('fileManager.copyModal.title')"
    :label="t('fileManager.copyModal.nameLabel')"
    :placeholder="t('fileManager.copyModal.namePlaceholder')"
    :submit-label="t('fileManager.copyModal.submitButton')"
    :cancel-label="t('fileManager.copyModal.cancel')"
    :close-aria-label="t('fileManager.copyModal.closeAriaLabel')"
    :initial-value="initialName"
    @submit="(name: string) => emit('copy', name)"
    @close="emit('close')"
  />
</template>
